import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeBonusMe } from "../redux/slices/navSlice";
import { Listbox } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import numeral from "numeral";
const KeepCredit = () => {
  const dispatch = useDispatch();
  const presenter = useSelector((state) => state.company.presenter);
  const nav = useSelector((state) => state.nav);
  const options = [
    { id: 1, text: "Keep for yourself (We won't tell)", bonusMe: true },
    {
      id: 2,
      text: `Include in gift (${numeral(presenter.credit_to_give).format(
        "$0,0[.]00",
      )} Gift Total)`,
      bonusMe: false,
    },
  ];

  const [selectedBonusOption, setSelectedBonusOption] = React.useState(
    nav.bonusMeGift ? options[0] : options[1],
  );
  const bonus_to_keep = numeral(
    presenter.credit_to_give - presenter.subtotal,
  ).format("$0,0[.]00");

  React.useEffect(() => {
    dispatch(changeBonusMe(selectedBonusOption.bonusMe));
  }, [selectedBonusOption]);

  return (
    <>
      <div className="inner-col">
        <div className="font-bold">
          What would you like to do with your {bonus_to_keep} Bonus?
        </div>
        <Listbox value={selectedBonusOption} onChange={setSelectedBonusOption}>
          {({ open }) => (
            <div className="listbox-wrapper">
              <Listbox.Button
                className={`card-select bonusme ${open && "open"}`}
              >
                <div className="card-display">{selectedBonusOption.text}</div>
                <ChevronDownIcon
                  className={`${open ? "rotated" : ""} chevron `}
                />
              </Listbox.Button>
              {open && (
                <div>
                  {/*
                Using `static`, `Listbox.Options` is always rendered and
                ignores the `open` state.
              */}
                  <Listbox.Options
                    className="listbox-options checkout-base-font"
                    static
                  >
                    {options
                      .filter((option) => option != selectedBonusOption)
                      .map((option) => (
                        <Listbox.Option
                          className="card-option bonusme"
                          key={option.id}
                          value={option}
                        >
                          {option.text}
                        </Listbox.Option>
                      ))}
                  </Listbox.Options>
                </div>
              )}
            </div>
          )}
        </Listbox>
      </div>
    </>
  );
};

export default KeepCredit;
